export const carouselInicio = [
   {
      "imagen" : "videos/PC_Escritorio.gif",
   },  
 
 
]